import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const phoneNumber = '0784417112';
  const email = 'floria@malerfixpreis.ch';

  return (
    <footer className="bg-black text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">Floria Maler Sanierung</h3>
            <p className="text-slate-300 mb-4">
              Professionelle Malerarbeiten in Zürich und Umgebung zum Fixpreis.
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-slate-300">
                <MapPin className="w-4 h-4" />
                <span>Fahrstrasse 7, 5314 Kleindöttingen</span>
              </div>
              <div className="flex items-center gap-2 text-slate-300">
                <Phone className="w-4 h-4" />
                <a href={`tel:${phoneNumber}`} className="hover:text-blue-400 transition-colors">
                  {phoneNumber}
                </a>
              </div>
              <div className="flex items-center gap-2 text-slate-300">
                <Mail className="w-4 h-4" />
                <a href={`mailto:${email}`} className="hover:text-blue-400 transition-colors">
                  {email}
                </a>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xl font-semibold mb-4">Unsere Leistungen</h4>
            <ul className="space-y-2 text-slate-300">
              <li>Wände streichen</li>
              <li>Decken streichen</li>
              <li>Wohnungen streichen</li>
              <li>Häuser streichen</li>
              <li>Weißanstrich für Wohnungsübergabe</li>
              <li>Auszugsrenovierung (Malerarbeiten)</li>
            </ul>
          </div>

          {/* Regions */}
          <div>
            <h4 className="text-xl font-semibold mb-4">Regionen</h4>
            <ul className="space-y-2 text-slate-300">
              <li>Zürich</li>
              <li>Winterthur</li>
              <li>Uster</li>
              <li>Dübendorf</li>
              <li>Dietikon</li>
              <li>Wetzikon</li>
              <li>Basel</li>
              <li>Weitere Orte auf Anfrage</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400">
              © {currentYear} Floria Maler Sanierung. Alle Rechte vorbehalten.
            </p>
            <div className="flex gap-6">
              <Link to="/impressum" className="text-slate-400 hover:text-blue-400 transition-colors">
                Impressum
              </Link>
              <a href="#datenschutz" className="text-slate-400 hover:text-blue-400 transition-colors">
                Datenschutz
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;